const soapNotePrompt = `### **SOAP Note**  

**Patient Information:**  
- **Name**: Unknown  
- **Gender**: Unknown  
- **Age**: Unknown  

---

**Subjective:**  
The patient reports warts on the right thumb and smaller ones on the left thumb and palm, expressing willingness for treatment.  

---

**Objective:**  
- Warts observed on right thumb and left hand.  
- Lesions appear in good condition and beginning to separate.  
- Planned treatment: Leomycin injections (0.4 ml for larger, 0.1 ml for smaller warts).  

---

**Assessment:**  
Warts responding to treatment, expected to darken and fall off.  

---

**Plan:**  
1. Administer Leomycin injections, followed by liquid estrogen.  
2. Advise monitoring of lesions and return if remnants persist.  
3. Follow-up in January (cancel if resolved).  
`



export default soapNotePrompt;